// PROD-8701: student and replacement-request value sets are both MALE/FEMALE/NO_PREFERENCE.
export const STUDENT_GENDER_PREFERENCE_DEFAULT = 'NO_PREFERENCE';

export const studentGenderPreferenceOptions = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'NO_PREFERENCE', label: 'Any Gender' }
];

const studentLabels = { MALE: 'Male', FEMALE: 'Female', NO_PREFERENCE: 'Any Gender' };
const requestLabels = { MALE: 'Male', FEMALE: 'Female', NO_PREFERENCE: 'Any Gender' };

const toUpper = (value) => (typeof value === 'string' ? value.trim().toUpperCase() : '');

// Saved student preference; unknown/missing falls back to NO_PREFERENCE (DB default).
export const normalizeStudentGenderPreference = (value) => {
  const upper = toUpper(value);
  return studentLabels[upper] ? upper : STUDENT_GENDER_PREFERENCE_DEFAULT;
};

// get_student_data has no top-level field yet, so fall back to the raw student row.
export const getStudentGenderPreference = (details) =>
  normalizeStudentGenderPreference(
    details?.teacher_gender_preference ?? details?.raw_data?.teacher_gender_preference
  );

export const studentGenderPreferenceLabel = (value) =>
  studentLabels[normalizeStudentGenderPreference(value)];

export const replacementGenderPreferenceLabel = (value) => requestLabels[toUpper(value)] || '-';

export const replacementRequestGenderCaption = (value) => {
  const upper = toUpper(value);
  if (upper === 'FEMALE') return 'Requested: Female teachers only';
  if (upper === 'MALE') return 'Requested: Male teachers only';
  return '';
};

export const teacherListGenderCaption = (value) => {
  const upper = toUpper(value);
  if (upper === 'FEMALE') return "Showing female teachers only — student's preference";
  if (upper === 'MALE') return "Showing male teachers only — student's preference";
  return '';
};
